'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BetaSticker = require('./components/BetaSticker.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BetaSticker).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/beta-sticker/index.js
// module id = 1279
// module chunks = 0